var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { goToAnchor } from 'react-scrollable-anchor';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import 'antd/lib/grid/style/index.css';
import 'antd/lib/layout/style/index.css';
import Page from '../templates/Page';
import CardOnboard from './CardOnboard';
import CardJoin from './CardJoin';
var selfStyles = require('./styles.scss');
var PageWelcome = (function (_super) {
    __extends(PageWelcome, _super);
    function PageWelcome(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isShowingCardJoin: false,
        };
        _this.handleShowCardJoin = _this.handleShowCardJoin.bind(_this);
        return _this;
    }
    PageWelcome.prototype.handleShowCardJoin = function () {
        this.setState({
            isShowingCardJoin: true,
        });
        goToAnchor('CardJoin');
    };
    PageWelcome.prototype.render = function () {
        return (React.createElement(Page, { documentTitle: 'Welcome' },
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: 24, md: 12 },
                    React.createElement(CardOnboard, { className: selfStyles.card, handleShowCardJoin: this.handleShowCardJoin })),
                React.createElement(Col, { xs: 24, md: 12 }, this.state.isShowingCardJoin && React.createElement(CardJoin, { className: selfStyles.card })))));
    };
    return PageWelcome;
}(React.Component));
export default PageWelcome;



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageWelcome/index.tsx
// module id = 729
// module chunks = 0